import { useTranslation } from 'react-i18next';
import {
  PerformanceManagerContainer,
  StyledListPageHeader,
  MainContainer,
} from './PerformanceManagement.styled';

import AddFeedbackMeetingCycleModal from './AddFeedbackMeetingCycleModal/AddFeedbackMeetingCycleModal';
import FeedbackMeetingCycles from './FeedbackMeetingCycles/FeedbackMeetingCycles';

const PerformanceManagement = () => {
  const { t } = useTranslation();

  return (
    <PerformanceManagerContainer>
      <StyledListPageHeader
        t={t}
        titleTxt="x.scales.performance_manager.header.title"
        subTitleTxt="x.scales.performance_manager.header.subtitle"
      />
      <MainContainer>
        <AddFeedbackMeetingCycleModal />

        <FeedbackMeetingCycles />
      </MainContainer>
    </PerformanceManagerContainer>
  );
};

export default PerformanceManagement;
